import React, {Component} from 'react';
import {COLORS} from '../constants';
import {ProgramSection as pss} from '../strings';
import '../css/ProgramSection.css'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class ProgramSection extends Component {

  static defaultProps = {
    id: 1,
  }

  state = {expanded: false};

  handleChange = (params = {}) => {
    //const {caller} = params;

    this.setState({expanded: !this.state.expanded});

    // ** NOT USING BELOW "caller" right now
    // don't do scroll adjustment if
    // click is initiated from footer
    // close button: this causes a weird
    // UI effect.
    //if (!this.state.expanded && caller !== 'footer') {
    if (!this.state.expanded) {
      const header = this.header;
      const end = header.offsetTop;
      window.scroll({
        top: end - 110,
        behavior: 'smooth',
      })
    }
    
  }

  makeId() {
    const {id} = this.props;
    const compId = `ProgramSection-${id}`;
    return compId;
  }

  renderSessions() {
    const {content, lang} = this.props;
    return content.sessions.map((s, index) => (
      <Session
        key={index}
        session={s}
        lang={lang}
      />
    ))
  }

  render() {
    const {
      content,
      lang,
    } = this.props;

    const {expanded} = this.state;

    const label = expanded
      ? pss.hide[lang]
      : pss.details[lang];

    return(
      <div style={s.container} className='program-section'>

        <button
          style={s.header}
          className="section-header"
          onClick={this.handleChange}
          ref={el => this.header = el}
        >
          <div style={s.titleContainer}>
            <div style={s.title}>
              {content.title[lang]}
            </div>
            <div style={s.expandButtonLabel} className='expand-button-label'>
              {label}
            </div>
            <div className='expand-button-small'>
              <FontAwesomeIcon
                icon={'chevron-down'}
                className={`expand-icon ${expanded ? 'rotated' : ''}`}
              />
            </div>
          </div>
          
          <div style={s.subtitle}>
            {content.subtitle[lang]}
          </div>
        </button>

        {this.state.expanded &&
          <div style={s.content}>
            <div style={s.sessions}>
              {this.renderSessions()}
            </div>
            <button
              style={s.footer}
              className="expand-button"
              onClick={() => this.handleChange({caller: 'footer'})}
            >
              <div style={s.expandButtonLabel}>
                {label}
              </div>
            </button>
          </div>
        }
      </div>
    )
  }
}


const Session = (props) => {
  const {session, lang} = props;

  const renderChapters = () => session.chapters.map((c, index) => (
    <Chapter
      key={index}
      chapter={c}
      lang={lang}
    />
  ))

  const s = {
    container: {
      marginBottom: '0px',
      paddingBottom: '20px',
      //borderBottom: 'solid 1px ' + COLORS.lightGray,
      //borderTop: 'solid 1px ' + COLORS.gray100,
      //borderLeft: 'none',
      //borderRadius: '5px',

    },
    header: {
      marginBottom: '20px',
      //backgroundColor: COLORS.gray100,
    },
    title: {
      fontSize: '110%',
      fontWeight: 'bold',
      color: COLORS.gray200,
    },
    items: {

    },
  }

  return (
    <div style={s.container}>
      <div style={s.header}>
        <div style={s.title}>
          {session.title[lang]}
        </div>
      </div>
      <div style={s.items}>
        {renderChapters()}
      </div>
    </div>
  )
}


const Chapter = (props) => {
  const {chapter, lang} = props;
  const sections = chapter.sections || [];

  const renderSections = () => sections.map((sec, index) => (
    <Section
      key={index}
      section={sec}
      lang={lang}
    />
  ))

  const s = {
    container: {
      marginBottom: '40px',
    },
    header: {
      marginBottom: '20px',
    },
    title: {
      fontStyle: 'italic',
      fontSize: '90%',
      //fontWeight: 'bold',
      color: COLORS.gray200,
    },
    items: {

    },
  }

  return (
    <div style={s.container}>
      <div style={s.header}>
        <div style={s.title}>
          {chapter.title[lang]}
        </div>
      </div>
      <div style={s.items}>
        {renderSections()}
      </div>
    </div>
  )
}


const Section = (props) => {
  const {section, lang} = props;
  const sections = section.sections || [];

  const renderSections = () => sections.map((sec, index) => (
    <SubSection
      key={index}
      section={sec}
      lang={lang}
    />
  ))

  const s = {
    container: {
      marginLeft: '30px',
      marginBottom: '10px',
    },
    header: {
      display: 'flex',
      //marginBottom: '10px',
    },
    bullet: {
      marginRight: '10px',
      color: COLORS.gray200,
      fontSize: '80%',
    },
    title: {
      color: COLORS.gray200,
      fontSize: '80%',
    },
    items: {
      marginTop: '20px',
    },
  }

  return (
    <div style={s.container}>
      <div style={s.header}>
        <div style={s.bullet}>
          -
        </div>
        <div style={s.title}>
          {section.title[lang]}
        </div>
      </div>
      {sections.length > 0 &&
        <div style={s.items}>
          {renderSections()}
        </div>
      }
    </div>
  )
}

const SubSection = (props) => {
  const {section, lang} = props;

  const s = {
    container: {
      marginLeft: '30px',
      marginBottom: '20px',
    },
    header: {
      display: 'flex',
      //marginBottom: '10px',
    },
    bullet: {
      marginRight: '10px',
    },
    title: {
      color: COLORS.gray200,
      fontSize: '90%',
    },
    items: {

    },
  }

  return (
    <div style={s.container}>
      <div style={s.header}>
        <div style={s.bullet}>
          -
        </div>
        <div style={s.title}>
          {section.title[lang]}
        </div>
      </div>
    </div>
  )
}


const s = {
  container: {
    border: 'solid 1px ' + COLORS.gray100,
    borderRadius: '5px',
    marginBottom: '45px',
  },
  header: {
    padding: '30px',
    paddingBottom: '30px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  title: {
    fontSize: '120%',
    fontWeight: 'bold',
    marginRight: '40px',
    color: COLORS.gray200,
  },
  expandButtonLabel: {
    color: COLORS.orange,
    fontSize: '70%',
    fontStyle: 'italic',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subtitle: {
    color: COLORS.gray200,
    fontSize: '80%',
    //marginBottom: '20px',
  },
  sessions: {
    //padding: '40px 40px',
    padding: '30px 30px 0',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '60px 30px',
  },
}

export default ProgramSection;



// WEBPACK FOOTER //
// ./src/main/ProgramSection.js